// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "GlobalSearch-module--bx--text-truncate--end--B5YD0";
export var bxTextTruncateFront = "GlobalSearch-module--bx--text-truncate--front--D+Xvw";
export var container = "GlobalSearch-module--container--UinBu";
export var inputFocusWithin = "GlobalSearch-module--inputFocusWithin--1fQ7S";
export var hidden = "GlobalSearch-module--hidden--CbrXJ";
export var inputWrapper = "GlobalSearch-module--inputWrapper--AFaN3";
export var input = "GlobalSearch-module--input--i-NxR";
export var label = "GlobalSearch-module--label--GpuqJ";
export var list = "GlobalSearch-module--list--Wbah0";
export var tab = "GlobalSearch-module--tab--66Cqq";
export var description = "GlobalSearch-module--description--b2HeA";
export var link = "GlobalSearch-module--link--et593";
export var searchButton = "GlobalSearch-module--searchButton--h3xR0";
export var inactive = "GlobalSearch-module--inactive--CYSoL";
export var searchButtonClose = "GlobalSearch-module--search-button--close--Hz4-A";
export var active = "GlobalSearch-module--active--7vO1K";
export var skeleton = "GlobalSearch-module--skeleton--i95Nl";